<template>
  <div class="timeline-hours">
    <div
      v-for="hour in hours"
      :key="hour"
      class="hour-marker"
      :style="{ left: `${getHourPosition(hour)}px` }"
    >
      <span class="hour-label">{{ hour }}:00</span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  startHour: number;
  endHour: number;
  hourWidth: number;
}

const props = defineProps<Props>();

// Generate hours array (exclude the last hour label)
const hours = computed(() => {
  const result = [];
  for (let i = props.startHour; i < props.endHour; i++) {
    result.push(i);
  }
  return result;
});

// Position calculation
const getHourPosition = (hour: number): number => {
  return (hour - props.startHour) * props.hourWidth;
};
</script>

<style lang="sass" scoped>
.timeline-hours
  position: relative
  height: 30px
  width: calc(24 * 60px)
  user-select: none
  cursor: inherit

  @media (max-width: 768px)
    width: calc(24 * 50px)

.hour-marker
  position: absolute
  top: 0
  height: 30px
  border-left: 1px solid #e0e0e0
  cursor: inherit

  .hour-label
    position: absolute
    top: 7px
    left: 5px
    font-size: 11px
    color: #666
    white-space: nowrap
    cursor: inherit
</style>

